/*
 * Angel Ruche wishlist PAGE logic (loaded by sections/ar-wishlist.liquid).
 * Renders wishlist cards from localStorage with an inline size picker +
 * add-to-cart. Self-heals a bad/stale product handle by searching the stored
 * title, so options always load even if a product was renamed.
 */
(function(){
  var WL_KEY='ar_wishlist';
  var NL=String.fromCharCode(10);
  function getWL(){ try{ return JSON.parse(localStorage.getItem(WL_KEY)||'[]'); }catch(e){ return []; } }
  function setWL(a){ try{ localStorage.setItem(WL_KEY,JSON.stringify(a)); }catch(e){} }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function handleFromUrl(u){ if(!u) return ''; var p=String(u).split('/products/')[1]; if(!p) return ''; return p.split('?')[0].split('#')[0].split('/')[0]; }
  function priceHtml(raw){
    var s=String(raw==null?'':raw).replace(/regular price|sale price|unit price|from|per /gi, NL);
    var tokens=s.split(NL).map(function(x){return x.trim();}).filter(Boolean);
    if(!tokens.length) return esc(raw||'');
    if(tokens.length>=2){ return '<span class="ar-wl-was">'+esc(tokens[0])+'</span><span class="ar-wl-now">'+esc(tokens[tokens.length-1])+'</span>'; }
    return esc(tokens[0]);
  }
  var grid=document.querySelector('.ar-wl-grid');
  var empty=grid?grid.querySelector('.ar-wl-empty'):null;
  if(!grid) return;

  function render(){
    var cards=grid.querySelectorAll('.ar-card');
    for(var i=0;i<cards.length;i++) cards[i].parentNode.removeChild(cards[i]);
    var wl=getWL();
    if(!wl.length){ if(empty) empty.style.display='block'; return; }
    if(empty) empty.style.display='none';
    wl.forEach(function(p){
      var url=p.url||('/products/'+p.handle);
      var card=document.createElement('div');
      card.className='ar-card';
      card.setAttribute('data-handle', p.handle);
      card.innerHTML=
        '<div class="ar-ph">'
          +'<a class="ar-ph-link" href="'+esc(url)+'">'+(p.img?'<img src="'+esc(p.img)+'" alt="'+esc(p.title)+'" loading="lazy">':'')+'</a>'
          +'<button type="button" class="ar-rmv" data-rmv="'+esc(p.handle)+'" aria-label="Remove from wishlist" title="Remove from wishlist">&#9829;</button>'
        +'</div>'
        +'<a class="ar-name-link" href="'+esc(url)+'"><h4 class="ar-name">'+esc(p.title)+'</h4></a>'
        +'<div class="ar-price">'+priceHtml(p.price)+'</div>'
        +'<div class="ar-atc">'
          +'<button type="button" class="ar-atc-btn">Add to cart</button>'
          +'<div class="ar-atc-sizes" hidden></div>'
          +'<p class="ar-atc-msg" hidden></p>'
        +'</div>';
      grid.insertBefore(card, empty);
    });
  }
  render();

  function msg(card,text){ var m=card.querySelector('.ar-atc-msg'); if(m){ m.textContent=text; m.hidden=!text; } }
  function titleOf(card){ var el=card.querySelector('.ar-name'); return el?el.textContent.trim():''; }

  function refreshCartAndOpen(){
    var bar=document.querySelector('cart-progress-bar');
    if(bar && typeof bar.refreshSections==='function') bar.refreshSections();
    var drawer=document.querySelector('cart-drawer');
    if(drawer && typeof drawer.open==='function'){ setTimeout(function(){ drawer.open(); }, 450); }
    if(window.AR_WL) window.AR_WL.toast('Added to cart');
  }

  function addVariant(card, id, btn){
    if(btn) btn.classList.add('is-loading');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(btn) btn.classList.remove('is-loading');
        if(res && res.status){ msg(card, res.description || 'Could not add to cart'); return; }
        var sizes=card.querySelector('.ar-atc-sizes'); if(sizes){ sizes.hidden=true; }
        msg(card,''); refreshCartAndOpen();
      })
      .catch(function(){ if(btn) btn.classList.remove('is-loading'); msg(card,'Could not add to cart'); });
  }

  function searchByTitle(title){
    if(!title) return Promise.reject(new Error('no-title'));
    var q=encodeURIComponent(title);
    return fetch('/search/suggest.json?q='+q+'&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=last')
      .then(function(r){ if(!r.ok) throw new Error('search-failed'); return r.json(); })
      .then(function(j){
        var list=(j.resources&&j.resources.results&&j.resources.results.products)||[];
        if(!list.length) throw new Error('not-found');
        var h=handleFromUrl(list[0].url);
        if(!h) throw new Error('not-found');
        return h;
      });
  }

  function fetchProduct(card){
    var handle=card.getAttribute('data-handle');
    return fetch('/products/'+handle+'.js').then(function(r){
      if(r.ok) return r.json().then(function(p){ p.__handle=handle; return p; });
      return searchByTitle(titleOf(card)).then(function(real){
        return fetch('/products/'+real+'.js').then(function(r2){
          if(!r2.ok) throw new Error('not-found');
          return r2.json().then(function(p){ p.__handle=real; return p; });
        });
      });
    });
  }

  function healHandle(card, newHandle){
    var oldHandle=card.getAttribute('data-handle');
    if(!newHandle || newHandle===oldHandle) return;
    card.setAttribute('data-handle', newHandle);
    var wl=getWL(), changed=false;
    for(var i=0;i<wl.length;i++){ if(wl[i].handle===oldHandle){ wl[i].handle=newHandle; wl[i].url='/products/'+newHandle; changed=true; } }
    if(changed) setWL(wl);
  }

  function openPicker(card, btn){
    var box=card.querySelector('.ar-atc-sizes');
    if(box.getAttribute('data-loaded')==='1'){ box.hidden=!box.hidden; return; }
    btn.classList.add('is-loading');
    msg(card,'');
    fetchProduct(card).then(function(p){
      btn.classList.remove('is-loading');
      healHandle(card, p.__handle);
      var variants=(p&&p.variants)||[];
      if(!variants.length){ msg(card,'Sorry, this item is unavailable right now'); return; }
      if(variants.length===1){ addVariant(card, variants[0].id, btn); return; }
      var html='<span class="ar-atc-sizes-label">Choose an option</span>';
      variants.forEach(function(v){
        html+='<button type="button" class="ar-size" data-vid="'+v.id+'"'+(v.available?'':' disabled')+'>'+esc(v.title)+'</button>';
      });
      box.innerHTML=html;
      box.setAttribute('data-loaded','1');
      box.hidden=false;
    }).catch(function(){
      btn.classList.remove('is-loading');
      var link=card.querySelector('.ar-name-link');
      var href=link?link.getAttribute('href'):'';
      msg(card, href ? 'Tap the product to choose options' : 'Could not load options');
    });
  }

  grid.addEventListener('click',function(e){
    var rmv=e.target.closest('[data-rmv]');
    if(rmv){ e.preventDefault(); var h=rmv.getAttribute('data-rmv'); setWL(getWL().filter(function(x){ return x.handle!==h; })); render(); if(window.AR_WL) window.AR_WL.update(); return; }
    var size=e.target.closest('.ar-size');
    if(size){ e.preventDefault(); if(size.disabled) return; var card=size.closest('.ar-card'); addVariant(card, size.getAttribute('data-vid'), card.querySelector('.ar-atc-btn')); return; }
    var atc=e.target.closest('.ar-atc-btn');
    if(atc){ e.preventDefault(); openPicker(atc.closest('.ar-card'), atc); return; }
  });
})();
